import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {

  @Input() users:{email:string, id:number, lastname:string, name:string, user:string}[] = [];
  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();


  buttonModificate: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Modificar',
    icon: Constants.ICONS.PENCIL_BLUE,
  };

  kebabButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  onActionMenu(action:string, user:any) {
    if(action && user) {
      const dto = {
        action:action, user:user
      }
      this.onAction.emit(dto);
    }
  }

  onModificate(action:string, id:string | number) {
    if(action && id) {
      const dto = {
        action:action, id:id
      }
      this.onAction.emit(dto);
    }
  }

}
